import { CustomGridFilter } from './CustomGrid';
import CustomButton from '../buttons/CustomButton';
import RightButtonArea from '../buttons/RightButtonArea';
import CustomSearchBox from '../customSearchBox/CustomSearchBox';
import { CustomSwitch } from '../CustomSwitch';
import { Add } from '@material-ui/icons';
import React from 'react';

interface GridActionsProps<RowType> {
  addButtonTooltip: NonNullable<React.ReactNode>;
  filters?: CustomGridFilter<RowType>[];
  hideAddButton?: boolean;
  hideSearchBar?: boolean;
  onAddClick: (event: any) => void;
  onSearchTokenChanged?: (searchToken: string) => void;
  searchToken: string;
  tag?: boolean;
  additionalButtons?: "" | JSX.Element;
}
export class GridActions<RowType> extends React.Component<GridActionsProps<RowType>> {
  public render() {
    if (this.props.hideAddButton && this.props.hideSearchBar && !this.props.filters) {
      return <React.Fragment />;
    }

    return (
      <RightButtonArea>
        {this.props.filters && this.renderSwitchFilters()}
        {!this.props.hideSearchBar && <CustomSearchBox onChange={this.handleSearchToken} searchToken={this.props.searchToken} tag={this.props.tag} />}
        {!this.props.hideAddButton && <CustomButton tooltip={this.props.addButtonTooltip} onClick={this.props.onAddClick}>
          <Add />
        </CustomButton>}
        {this.props.additionalButtons}
      </RightButtonArea>
    );
  }

  private renderSwitchFilters = () => {
    let switchFilters: JSX.Element[] = [];

    if (this.props.filters) {
      switchFilters = this.props.filters.map((filter: CustomGridFilter<RowType>, index: number) => {
        return <span key={index} style={switchFilter}><CustomSwitch label={filter.label} value={filter.isActive} onChange={filter.onFilterChange} /></span>;
      });
    }

    return switchFilters;
  };

  private handleSearchToken = (event: any) => {
    if (this.props.onSearchTokenChanged) {
      this.props.onSearchTokenChanged(event.target.value);
    }
  };
}

export default GridActions;

const switchFilter: React.CSSProperties = {
  marginRight: "10px",
};
